module.exports = __webpack_public_path__ + "static/media/logo-with-text.09681ead.svg";